export default __webpack_public_path__ + "static/media/Pr-logo.1d54fac1.png";